<template>
  <div class="version-number">
    <span class="version-number__title">Build Id: </span>
    <span class="version-number__content">{{ version }}</span>
  </div>
</template>

<script>
export default {
  name: 'Version',

  data: () => ({
    version: process.env.SENTRY_RELEASE
  })
}
</script>

<style lang="scss" scoped>
.version-number {
  position: absolute;
  bottom: $spacer-unit-small;
  left: $gutter;
  margin: 0 0 0 $border-radius-default;
  color: $grey-light;
  font-size: $font-size-small;
}
</style>
